import Page from "components/Page";
import SupplierFeedback from "./SupplierFeedbackList";

export default () => (
  <Page>
    <SupplierFeedback />
  </Page>
);
